import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "full-width" }

import { QTable, QTableProps } from "quasar"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import { TABLE_COLUMN_STATUS } from "src/util/constants/table"
import { RowData, StatusColumnNames, StatusSortColumn } from "src/util/types/components/sfxTable"
import { computed, PropType, ref } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxTableThStatus',
  props: {
  pagination: {
    type: Object as PropType<QTableProps["pagination"]>,
    required: true,
  },

  table: {
    type: Object as PropType<QTable>,
    required: true,
  },

  statusColumns: {
    type: Array as PropType<StatusColumnNames[]>,
    required: true,
  },
},
  emits: ["update:pagination", "update:table"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

__expose({ sortStatus })

//endregion

//region Variables

const columnName = TABLE_COLUMN_STATUS
const { t } = useI18n()

const pagination = computed({
  get() {
    return props.pagination
  },

  set(value) {
    return emit("update:pagination", value)
  },
})

const table = computed({
  get() {
    return props.table
  },

  set(value) {
    return emit("update:table", value)
  },
})

const statusMenuOpen = ref(false)
const statusSortTarget = ref<StatusColumnNames | null>(null)
const statusButtonText = t("sfxTable.status_dropdown")
const sortByText = t("sfxTable.status_sort_by")

const statusClass = computed(() => {
  return {
    "sfx-table__th-status-open": statusMenuOpen.value,
    "sfx-table__th-status-active": !statusMenuOpen.value && pagination.value?.sortBy === columnName,
  }
})

const allSortEntries: Map<string, StatusSortColumn> = new Map([
  ["change-request", { text: t("sfxTable.status_change_request"), name: "change-request" }],
  ["work-order", { text: t("sfxTable.status_work_order"), name: "work-order" }],
  ["corrective-work", { text: t("sfxTable.status_corrective_work"), name: "corrective-work" }],
  ["done", { text: t("sfxTable.status_done"), name: "done" }],
  ["issue", { text: t("sfxTable.status_issue"), name: "issue" }],
  ["issue-overdue", { text: t("sfxTable.status_issue_overdue"), name: "issue-overdue" }],
  [
    "corrective-work-accepted",
    { text: t("sfxTable.status_corrective_work_accepted"), name: "corrective-work-accepted" },
  ],
  ["closed", { text: t("sfxTable.status_closed"), name: "closed" }],
])

const statusSortEntities = computed<StatusSortColumn[]>(() => {
  const sortColumns: StatusSortColumn[] = []
  for (const statusColumn of props.statusColumns) {
    const foundColumn = allSortEntries.get(statusColumn)
    if (foundColumn) {
      sortColumns.push(foundColumn)
    }
  }
  return sortColumns
})

const statusMenuActive = computed(
  () => statusMenuOpen.value && pagination.value?.sortBy === columnName
)

//endregion

//region Functions

async function triggerStatusSort(target: StatusColumnNames) {
  if (!table.value || !pagination.value) return
  const previousTarget = statusSortTarget.value
  statusSortTarget.value = target

  await table.value.sort(columnName)

  if (previousTarget && previousTarget !== target) {
    pagination.value.descending = false
    pagination.value.sortBy = columnName
  }
}

function sortStatus(a: RowData, b: RowData, dir: number) {
  const A = a[columnName]
  const B = b[columnName]

  let aIcon
  let bIcon

  if (A) aIcon = A.find((icon) => icon.column === statusSortTarget.value)
  if (B) bIcon = B.find((icon) => icon.column === statusSortTarget.value)

  if (!bIcon || bIcon.sortData === null) return -1
  if (!aIcon || aIcon.sortData === null) return +1

  return (aIcon.sortData - bIcon.sortData) * dir
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_th = _resolveComponent("q-th")!

  return (_openBlock(), _createBlock(_component_q_th, {
    onTouchstart: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
    onMousedown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
    onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent","stop"])),
    class: "sfx-table__th-status no-pointer-events"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent","stop"]))
      }, [
        _createVNode(SfxBtnOutline, {
          label: _unref(statusButtonText),
          dense: "",
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent","stop"])),
          class: _normalizeClass(["q-px-md all-pointer-events", statusClass.value])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_menu, {
              modelValue: statusMenuOpen.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((statusMenuOpen).value = $event)),
              anchor: "bottom right",
              self: "top right",
              offset: [0, 10],
              "auto-close": "",
              class: "sfx-table__th-status-menu"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_list, {
                  dense: "",
                  padding: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item, { class: "text-subtitle2 text-fun-label-and-icon" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(sortByText)), 1)
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusSortEntities.value, (entry) => {
                      return (_openBlock(), _createBlock(_component_q_item, {
                        key: entry.name,
                        class: _normalizeClass(["sfx-table__th-status-menu-item text-subtitle1 text-navy-base items-center", [
                  {
                    'sfx-table__th-status-menu-item-active':
                      statusMenuActive.value && entry.name === statusSortTarget.value,
                  },
                  `sfx-table__th-status-menu-item-active-${pagination.value.descending ? 'down' : 'up'}`,
                ]]),
                        clickable: "",
                        onClick: ($event: any) => (triggerStatusSort(entry.name))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_1, _toDisplayString(entry.text), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "class"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label", "class"])
      ])
    ]),
    _: 1
  }))
}
}

})